export const ua = {
    activeGame: {
        activeSession: 'Активна сесія',
        askAdministrator: 'Попросіть адміністратора розпочати гру',
        askMarker: 'Попросіть маркера розпочати гру',
        askMarkerToClose: 'Щоб закрити стіл, зверніться до маркера',
        atTheTable: 'За столом',
        bookTable: 'Забронювати стіл',
        bookTableComingSoon: 'Бронювання столів з вашого кабінету скоро з’явиться. Будь ласка, попросіть адміністратора розпочати гру.',
        closeTable: 'Закрити стіл',
        editProfile: 'Редагувати профіль',
        endSet: 'Завершити цикл',
        hello: 'Вітаємо, {{name}}',
        live: 'Наживо',
        loading: 'Завантаження даних сесії...',
        logout: 'Вийти',
        pause: 'Пауза',
        pauseAccrued: 'Пауза (накопичена)',
        pauseFull: 'Пауза {{minutes}} хв',
        pauseAvailable: 'Доступна пауза',
        pauseRemaining: 'Залишок паузи',
        lowPauseWarning:
            'На жаль, доступної паузи залишилося менше 30 секунд. Будь ласка, пограйте ще трохи, щоб накопичити більше часу паузи, або зверніться до маркера, якщо потрібна довша перерва.',
        paused: 'На паузі',
        playedTime: 'Час гри',
        resume: 'Продовжити',
        started: 'Розпочато',
        tableFallback: 'Стіл {{tableId}}',
        multipleGames: 'У вас {{count}} активних ігор',
        videoRecording: 'Відеозапис',
        foulReview: 'Перегляд фолу',
        clipEditing: 'Монтаж кліпу',
        lateVideoRecording: 'Пізній відеозапис',
        callWaiter: 'Викликати офіціанта',
    },
    foulReview: {
        title: 'Перегляд фолу',
        preparing: 'Готуємо останній відеозапис…',
        scrollHint: 'Перемотайте до кінця, щоб побачити щойно. Потягніть раніше або натисніть «Раніше», щоб підвантажити ще.',
        loadingEarlier: 'Завантаження ранішого відео…',
        loadEarlier: 'Завантажити раніший кліп',
        noEarlier: 'Ранішого відео в архіві немає',
        close: 'Закрити',
        addFree: 'Готово — входить у відеотариф',
        addCharge: 'Додати фол · {{amount}} грн',
        retry: 'Спробувати знову',
        failedOpen: 'Не вдалося відкрити перегляд фолу.',
        webOnly: 'Перегляд фолу доступний у веб-версії.',
        playbackError: 'Не вдалося відтворити відео ({{detail}}). Оновіть video-orchestrator або перевірте кодек камери.',
        mute: 'Без звуку',
        unmute: 'Звук',
        jumpLatest: 'Кінець',
    },
    userHome: {
        profile: 'Профіль',
        // TEMPORARY — remove when user cabinet leaves testing
        testingNotice: 'Кабінет користувача на тестуванні. Питання та пропозиції обговорюйте з маркером',
        loyaltyInfoA11y: 'Як працює програма лояльності',
    },
    gameDiscipline: {
        PYRAMID: 'Піраміда',
        POOL: 'Пул',
        HEYBALL: 'Хейбол',
        SNOOKER: 'Снукер',
    },
    gameVariant: {
        FREE: 'Вільна',
        DYNAMIC: 'Динамічна',
        COMBINATION: 'Комбінована',
        CLASSIC: 'Класична',
        SAUSAGE: 'Ковбаса',
        EIGHT_BALL: '8-куль',
        NINE_BALL: '9-куль',
        STRAIGHT: 'Прямий пул',
        STANDARD: 'Стандарт',
    },
    rivalSearch: {
        title: 'Пошук суперника',
        createCta: 'Шукаю суперника',
        createTitle: 'Шукаю суперника',
        offerTitle: 'Запропонувати гру',
        imInterested: 'Мені цікаво',
        gameLabel: 'Гра',
        rulesLabel: 'Правила',
        whenLabel: 'Коли',
        whenNow: 'Зараз',
        whenTodayEvening: 'Сьогодні ввечері',
        whenTomorrow: 'Завтра',
        whenSpecific: 'Точний час',
        anyRules: 'Будь-які',
        createConsent:
            'Гравці, які відгукнуться, передадуть вам свої контактні дані.',
        offerConsent:
            'Відгукуючись, ви передаєте свої контактні дані автору запиту.',
        submit: 'Надіслати',
        filterAll: 'Усі',
        emptyBoard: 'Поки ніхто не шукає — станьте першим.',
        emptyFiltered: 'Немає запитів для цієї гри.',
        yours: 'Ваш',
        createSuccess: 'Запит на пошук суперника опубліковано.',
        createFailed: 'Не вдалося опублікувати запит.',
        disciplineRequired: 'Оберіть гру.',
        interestFailed: 'Не вдалося відгукнутись.',
        contactTelegram: 'Telegram',
        contactPhone: 'Телефон',
        contactEmail: 'Email',
        requestDetail: 'Ваш запит суперника',
        interestedPlayers: 'Зацікавлені гравці',
        noInterestsYet: 'Поки ніхто не відгукнувся.',
        continueSearch: 'Продовжити пошук',
        rivalFound: 'Суперника знайдено',
        closedSuccess: 'Суперника знайдено — запит закрито.',
        closeFailed: 'Не вдалося закрити запит.',
        loadFailed: 'Не вдалося завантажити запит.',
        interestCount: '{{count}} зацікавлених',
        staffButton: 'Пошук суперника',
    },
    clubContact: {
        instagram: 'Instagram',
        telegram: 'Telegram',
        telegramChat: '(Chat)',
        telegramChatA11y: 'Telegram чат',
        callPhone: 'Зателефонувати {{phone}}',
    },
    userBooking: {
        orDivider: 'АБО',
        modalTitle: 'Забронювати стіл',
        tableType: 'Тип столу',
        tableTypeRequired: 'Будь ласка, оберіть тип столу.',
        noTableTypes: 'Наразі немає доступних типів столів для бронювання.',
        dateLabel: 'Дата',
        dateToday: 'Сьогодні',
        dateTomorrow: 'Завтра',
        datePick: 'Обрати дату',
        notes: 'Примітка',
        notesPlaceholder: 'наприклад, хочу стіл 5, 6 або 7',
        cancel: 'Скасувати',
        submit: 'Забронювати стіл',
        submitSuccess: 'Запит на бронювання надіслано.',
        submitFailed: 'Не вдалося надіслати запит на бронювання.',
        pendingThanks: 'Дякуємо за бронювання. Будь ласка, зачекайте на підтвердження або зателефонуйте {{phone}}.',
        pendingThanksNoPhone: 'Дякуємо за бронювання. Будь ласка, зачекайте на підтвердження.',
        confirmedWaiting: '{{tableName}} чекає на вас {{date}} о {{time}}',
        bookedTable: 'Заброньований стіл',
    },
    notifications: {
        addPlayerComingSoon: 'Функція додавання гравця скоро з’явиться!',
        addPlayerBeforeFinishing: 'Додайте хоча б одного гравця перед завершенням партії.',
        addPlayerBeforeStopping: 'Додайте хоча б одного гравця перед зупинкою столу.',
        addPlayerFailed: 'Не вдалося додати гравця.',
        playerAdded: 'Гравця додано до сесії.',
        playerMarkedLeft: 'Гравця позначено як такого, що пішов.',
        markPlayerLeftFailed: 'Не вдалося позначити гравця як такого, що пішов.',
        failedFinishSet: 'Не вдалося завершити цикл: {{message}}',
        failedLoadSetSummary: 'Не вдалося завантажити підсумок циклу: {{message}}',
        failedPauseTable: 'Не вдалося поставити стіл на паузу: {{message}}',
        failedResumeTable: 'Не вдалося відновити стіл: {{message}}',
        failedStopTable: 'Не вдалося зупинити стіл: {{message}}',
        selectedUser: 'Обраний користувач: {{name}}',
        setFinished: 'Цикл успішно завершено.',
        tablePaused: '{{tableName}} успішно поставлено на паузу',
        tableResumed: '{{tableName}} успішно відновлено',
        tableStopped: 'Стіл успішно зупинено.',
        videoRecordingEnabled: 'Тарифікацію відеозапису увімкнено.',
        videoRecordingDisabled: 'Тарифікацію відеозапису вимкнено.',
        foulReviewCharged: 'Нарахування за перегляд фолу додано до рахунку.',
        foulReviewFree: 'Перегляд фолу зафіксовано — входить у відеотариф.',
        clipEditingCharged: 'Нарахування за монтаж кліпу додано до рахунку.',
        failedVideoRecordingToggle: 'Не вдалося змінити тарифікацію відеозапису: {{message}}',
        failedVideoCharge: 'Не вдалося додати відео-нарахування: {{message}}',
        failedFoulReview: 'Не вдалося завершити перегляд фолу: {{message}}',
        waiterCalled: 'Офіціанта викликано для {{tableName}}',
        failedCallWaiter: 'Не вдалося викликати офіціанта: {{message}}',
    },
    playerSelection: {
        finishSet: 'Завершити цикл',
        finishSetMessage: 'Оберіть гравців, які сплатять за цей цикл. Потрібно обрати хоча б одного.',
        stopTable: 'Зупинити стіл',
        stopTableMessage: 'Оберіть гравців, які сплатять за час, що залишився. Потрібно обрати хоча б одного.',
        specialPayerWarning:
            'Увага: обрано лише {{player}} ({{kind}}), а за столом кілька гравців. Весь цикл буде пораховано за їхнім спецтарифом.',
        cancel: 'Скасувати',
        confirm: 'Підтвердити',
    },
    startTable: {
        addPlayerRequired: 'Будь ласка, додайте хоча б одного гравця',
        failedStart: 'Не вдалося запустити стіл',
        selectDuration: 'Будь ласка, оберіть тривалість',
        pauseAfterDuration: 'Пауза після завершення часу',
        withTrainer: 'З тренером',
        videoRecording: 'Відеозапис',
        startSession: 'Розпочати сесію',
        durationOptional: 'Тривалість (необов’язково)',
        customMinutes: 'Власне значення (хвилини)',
        enterMinutes: 'Введіть хвилини',
        selectedDuration: 'Обрано: {{minutes}} хвилин',
        typePlayerName: 'Введіть ім’я гравця...',
        addPlayer: 'Додати гравця',
        presets: {
            min30: '30 хв',
            hour1: '1 година',
            hour1_30: '1 год 30 хв',
            hours2: '2 години',
            hours2_30: '2 год 30 хв',
            hours3: '3 години',
        },
    },
    bookings: {
        upcomingTitle: 'Найближчі бронювання:',
        noUpcoming: 'Немає бронювань',
    },
    tableDetail: {
        tableType: 'Тип столу',
        status: 'Статус',
        tableId: 'ID столу',
        technicalInfo: 'Технічна інформація',
        lastHeartbeat: 'Останній сигнал',
        missedHeartbeats: 'Пропущені сигнали',
        notAvailable: 'Н/Д',
        startTable: 'Запустити стіл',
    },
    tariff: {
        current: 'Поточний',
        training: 'Тренування',
        maintenance: 'Обслуговування',
        sessionTariff: 'Тариф сесії',
        tariffName: 'Назва тарифу',
        pricePerHour: 'Ціна за годину',
        activeHours: 'Активні години',
        currentTariff: 'Поточний тариф',
        selectTariff: 'Оберіть тариф',
    },
    players: {
        addPlayer: 'Додати гравця',
        assigned: 'Призначено',
        guest: 'Гість',
        left: 'Пішов',
        markLeft: 'Пішов',
        placeholder: 'Пошук або введіть ім’я...',
        players: 'Гравці',
        tariffFallback: 'Тариф',
    },
    time: {
        minutesShort: 'хв',
        ongoing: 'триває',
    },
    reports: {
        title: 'Звіти',
        loading: 'Завантаження звіту...',
        group: {
            takings: 'Виручка та використання',
            insights: 'Аналітика',
            audit: 'Журнал дій',
        },
        report: {
            money: 'Гроші',
            tableActivity: 'Активність столів',
            militaryTariffs: 'Військові тарифи',
            tariffUsage: 'Використання тарифів',
            billsList: 'Список рахунків',
            peakHours: 'Пікові години',
            tableOccupancy: 'Завантаженість столів',
            topSpenders: 'Найбільші витрати',
            loyaltyHealth: 'Стан програми лояльності',
            tableActions: 'Дії зі столами',
            bonusActions: 'Дії з бонусами',
            userChanges: 'Зміни користувачів',
            billPayments: 'Оплати рахунків',
            writeOffs: 'Списання',
        },
        ui: {
            report: 'Звіт',
            month: 'Місяць',
            year: 'Рік',
            custom: 'Довільний',
            from: 'Від',
            to: 'До',
            prevMonth: 'Попередній місяць',
            nextMonth: 'Наступний місяць',
            prevYear: 'Попередній рік',
            nextYear: 'Наступний рік',
            rangeInvalid: 'Дата «Від» пізніша за дату «До»',
            tables: 'Столи',
            all: 'Усі',
            none: 'Жодного',
            nOfN: '{{on}} з {{total}}',
            noTablesSelected: 'Оберіть принаймні один стіл',
            exportCsv: 'Експорт CSV',
            exporting: 'Експортуємо...',
            exported: 'CSV експортовано',
            total: 'Разом',
            rows: 'Рядків',
            user: 'Користувач',
            allUsers: 'Усі користувачі',
            clearUser: 'Скинути фільтр користувача',
            noUsersMatch: 'Користувачів не знайдено',
            peak: 'Пік',
            peakHour: 'Пікова година',
            promoHeavy: 'Багато промо',
            filters: 'Фільтри',
            close: 'Закрити',
            retry: 'Повторити',
            resetFilters: 'Скинути фільтри',
        },
        fields: {
            ROLE: 'Роль',
            ENABLED: 'Активний',
            ACCOUNT: 'Обліковий запис',
            DELETED: 'Видалено',
            true: 'Так',
            false: 'Ні',
        },
        cols: {
            period: 'Період',
            card: 'Картка',
            cash: 'Готівка',
            income: 'Дохід',
            bonuses: 'Бонуси',
            withoutPay: 'Без оплати',
            totalSpent: 'Всього витрачено',
            minutes: 'Хвилини',
            sessions: 'Сесії',
            revenue: 'Виручка',
            amount: 'Сума',
            sets: 'Сети',
            commercialMinutes: 'Комерційні хв',
            totalMinutes: 'Всього хв',
            startTime: 'Початок',
            endTime: 'Кінець',
            table: 'Стіл',
            status: 'Статус',
            total: 'Разом',
            hour: 'Година',
            share: 'Частка',
            demand: 'Попит',
            availableHours: 'Доступні години',
            soldHours: 'Продані години',
            occupancy: 'Завантаженість',
            user: 'Користувач',
            spend: 'Витрати',
            promoShare: 'Частка промо',
            issued: 'Нараховано',
            redeemed: 'Списано',
            netChange: 'Чиста зміна',
            redemptionRate: 'Частка списання',
            outstanding: 'Залишок',
            time: 'Час',
            action: 'Дія',
            actor: 'Виконавець',
            adjustedBy: 'Змінив',
            balanceAfter: 'Баланс після',
            reason: 'Причина',
            changedBy: 'Змінив',
            field: 'Поле',
            oldValue: 'Було',
            newValue: 'Стало',
            bill: 'Рахунок',
            method: 'Спосіб',
            by: 'Ким',
        },
        tabs: {
            money: 'Гроші',
            tables: 'Активність столів',
            military: 'Військові тарифи',
            tariffUsage: 'Використання тарифів',
            tableActions: 'Дії зі столами',
            bonuses: 'Зміни бонусів',
            userChanges: 'Зміни користувачів',
            billPayments: 'Оплати рахунків',
            writeOffs: 'Списання',
            bills: 'Список рахунків',
        },
        presets: {
            month: 'Місяць',
            quarter: 'Квартал',
            year: 'Рік',
            custom: 'Власний',
        },
        filters: {
            period: 'Період',
            granularity: 'Деталізація',
            startLocal: 'Початок (місцевий час)',
            endLocal: 'Кінець (місцевий час)',
            table: 'Фільтр за столом',
            allTables: 'Усі',
            day: 'День',
        },
        tablePeriod: {
            day: 'День',
            month: 'Місяць',
            year: 'Рік',
        },
        granularity: {
            day: 'День',
            week: 'Тиждень',
            month: 'Місяць',
        },
        columns: {
            period: 'Період',
            table: 'Стіл',
            total: 'Разом',
            income: 'Дохід',
            withoutPay: 'Без оплати',
            commercial: 'Комерційний',
            commercialMinutes: 'Комерц. хв',
            commercialMin: 'Комерційні, хв',
            totalMinutes: 'Разом хв',
            minutes: 'Хв',
            time: 'Час',
            actor: 'Користувач',
            action: 'Дія',
            summary: 'Підсумок',
            targetUser: 'Обліковий запис',
            bonusDelta: 'Бонус',
            type: 'Тип',
            balanceAfter: 'Баланс',
            changedBy: 'Хто змінив',
            revision: 'Rev',
            role: 'Роль',
            enabled: 'Активний',
            player: 'Гравець',
            amount: 'Сума',
            paymentMethod: 'Метод',
            closeNote: 'Нотатка',
        },
        paymentTypes: {
            cash: 'Готівка',
            card: 'Картка',
            bonus: 'Бонус',
        },
        sections: {
            byTariff: 'За тарифом (ціноутворення сесії)',
            byTariffMinutes: 'За тарифом (хвилини)',
            tariffSplit: 'Розподіл за тарифами для {{table}}',
            paymentChart: 'За типом оплати (до {{count}} серій)',
            tariffMinutesChart: 'Хвилини за тарифом (до {{count}} серій)',
            totalPaid: 'Усього сплачено (UAH)',
            playTime: 'Час гри (хвилини)',
        },
        insights: {
            show: 'Показати аналітику',
            hide: 'Приховати аналітику',
        },
        views: {
            table: 'Таблиця',
            insights: 'Аналітика',
        },
        actions: {
            clearTable: 'Очистити фільтр за столом',
        },
        hints: {
            tableFilter: 'Оберіть стіл вище або торкніться рядка, щоб завантажити тренди столу.',
        },
        audit: {
            systemActor: 'Система',
            enabledYes: 'Так',
            enabledNo: 'Ні',
            tableActionSummary: '{{user}} зробив(ла) {{action}} для {{table}}',
            tableActions: {
                START: 'старт',
                PAUSE: 'пауза',
                RESUME: 'продовження',
                STOP: 'стоп',
                FINISH_SET: 'завершення сету',
                MARK_LEFT: 'позначення виходу',
            },
            bonusTypes: {
                REGISTRATION: 'Реєстрація',
                BIRTHDAY: 'День народження',
                PAYMENT_ACCRUAL: 'Нарахування з оплати',
                PAYMENT_REDEMPTION: 'Списання бонусів',
                ADMIN_ADJUST: 'Коригування адміном',
                ADMIN_SET: 'Встановлення адміном',
            },
        },
        empty: {
            money: 'Немає сплачених рядків у цьому діапазоні.',
            tables: 'Немає даних про столи у цьому діапазоні.',
            military: 'Немає використання військових тарифів у цьому діапазоні.',
            tariffUsage: 'Немає хвилин використання тарифів у цьому діапазоні.',
            paymentChart: 'Немає даних за цей період для графіка.',
            tariffUsageChart: 'Немає даних використання тарифів за цей період для графіка.',
            tableChart: 'Оберіть стіл, щоб побачити графіки трендів.',
            tableActions: 'Немає дій зі столами за цей день.',
            bonuses: 'Немає змін бонусів за цей день.',
            userChanges: 'Немає змін прав користувачів за цей день.',
            billPayments: 'Немає оплат рахунків за цей день.',
            writeOffs: 'Немає списань за цей день.',
            bills: 'Немає рахунків за цей період.',
            militaryTariffs: 'Немає використання військових тарифів за цей період.',
            bonusActions: 'Немає змін бонусів за цей період.',
            peakHours: 'За цей період не розпочато жодної сесії.',
            tableOccupancy: 'Немає даних про завантаженість за цей період.',
            topSpenders: 'Немає оплат зареєстрованих клієнтів за цей період.',
            loyaltyHealth: 'Немає активності програми лояльності за цей період.',
            tableActivity: 'Немає активності столів за цей період.',
            billsList: 'Немає рахунків за цей період.',
        },
        errors: {
            invalidPeriod: 'Оберіть коректний період. Для власного введіть місцеві дату й час.',
            loadMoney: 'Не вдалося завантажити звіт по грошах',
            loadTables: 'Не вдалося завантажити звіт про активність столів',
            loadMilitary: 'Не вдалося завантажити звіт по військових тарифах',
            loadTariffUsage: 'Не вдалося завантажити звіт використання тарифів',
            loadBills: 'Не вдалося завантажити рахунки',
            loadAudit: 'Не вдалося завантажити аудит-звіт',
        },
        military: {
            minutes: 'Хвилини',
            amount: 'Сума',
            sets: 'Сети',
            period: 'Період',
            hoursApprox: '~{{hours}} год',
        },
    },
    bills: {
        title: 'Рахунки',
        loading: 'Завантаження рахунків...',
        empty: 'Немає рахунків за обрану дату та фільтри.',
        emptyLines: 'Немає неоплачених рядків для обраних гравців.',
        filters: {
            table: 'Стіл',
            all: 'Усі',
            status: 'Статус',
            player: 'Гравець',
            noPlayers: 'Немає гравців з боргом',
        },
        status: {
            NEW: 'Новий',
            PARTIALLY_CLOSED: 'Частковий',
            CLOSED: 'Закритий',
        },
        columns: {
            start: 'Початок',
            end: 'Кінець',
            table: 'Стіл',
            status: 'Статус',
            total: 'Разом',
            paidByType: 'Сплачено за типом',
            createdUpdated: 'Створено / оновлено',
            player: 'Гравець',
            lineAmount: 'Сума',
            payment: 'Оплата',
        },
        errors: {
            load: 'Не вдалося завантажити рахунки',
            loadBill: 'Не вдалося завантажити рахунок',
        },
        detail: {
            closeBill: 'Закрити рахунок',
            closeLine: 'Закрити рахунок',
            closeWithoutPayment: 'Закрити без оплати',
            paid: 'Сплачено',
            paidAt: 'Сплачено: {{time}}',
            closedAtBy: 'Закрито о {{time}} — {{method}}',
            closedBy: 'Закрито — {{method}}',
            closedWithoutPayment: 'Закрито без оплати',
            closedWithoutPaymentAt: 'Закрито без оплати о {{time}}',
            note: 'Примітка',
            guest: 'Гість',
            loadingBill: 'Завантаження рахунку...',
            notFound: 'Рахунок не знайдено.',
            billTitle: 'Рахунок #{{id}}',
            gameSession: 'Ігрова сесія',
            start: 'Початок',
            end: 'Кінець',
            table: 'Стіл',
            segmentLine: '{{tariff}} - {{minutes}} хв - {{amount}}',
            lineTotal: 'Разом',
            grandTotal: 'РАЗОМ',
            printBill: 'Друкувати рахунок',
            printing: 'Друк...',
            tariffFallback: 'Тариф',
            editClosed: 'Редагувати оплату',
            splitLine: 'Розділити',
            unassigned: 'Непризначено',
            lineTypes: {
                PLAY: 'Гра',
                VIDEO_RECORDING: 'Відеозапис',
                FOUL_REVIEW: 'Перегляд фолу',
                CLIP_EDITING: 'Монтаж кліпу',
                LATE_VIDEO_RECORDING: 'Пізній відеозапис',
            },
        },
        notifications: {
            printSuccess: 'Рахунок надіслано на принтер.',
            printFailed: 'Не вдалося надрукувати рахунок',
            closedSuccess: 'Рахунок успішно закрито',
            closeFailed: 'Не вдалося закрити рахунок',
        },
        closeWithoutPayment: {
            titleLine: 'Закрити рядок рахунку без оплати',
            titleWhole: 'Закрити рахунок без оплати',
            confirm: 'Ви дійсно хочете закрити рахунок без оплати?',
            noteLabel: 'Примітка',
            notePlaceholder: 'Причина закриття без оплати',
            noteRequired: 'Будь ласка, введіть примітку',
            cancel: 'Скасувати',
            confirmButton: 'Закрити',
            success: 'Рахунок закрито без оплати',
            failed: 'Не вдалося закрити рахунок без оплати',
        },
        splitBill: {
            title: 'Розділити рядок рахунку',
            subtitle: '{{player}} — {{amount}}',
            playerPlaceholder: 'Імʼя гравця...',
            addPlayer: 'Додати гравця',
            splitSum: 'Сума розподілу',
            splitTotalMismatch: 'Розподіл має дорівнювати {{expected}} (отримано {{actual}})',
            playerNameRequired: 'Вкажіть імʼя гравця для кожного рядка',
            invalidPartAmount: 'Кожна частка має бути більшою за нуль',
            needMultipleParts: 'Додайте щонайменше двох гравців для розділення',
            confirm: 'Розділити',
            success: 'Рядок рахунку успішно розділено',
            failed: 'Не вдалося розділити рядок рахунку',
        },
        editClosed: {
            title: 'Редагувати закритий рядок',
            method: 'Спосіб оплати',
            allocations: 'Суми оплати',
            success: 'Закритий рядок оновлено',
            failed: 'Не вдалося оновити закритий рядок',
            splitMismatch: 'Суми мають дорівнювати {{expected}} (отримано {{actual}})',
            methods: {
                CASH: 'Готівка',
                CARD: 'Картка',
                BONUS: 'Бонуси',
                WITHOUT_PAYMENT: 'Без оплати',
            },
        },
    },
    booking: {
        title: 'Бронювання',
        back: 'Панель',
        loading: 'Завантаження доступності...',
        today: 'Сьогодні',
        tableFallback: 'Стіл {{id}}',
        wizard: {
            back: 'Назад',
            close: 'Закрити',
        },
        stream: {
            free: 'Вільно',
            inPlay: 'У грі',
            book: 'Забронювати',
            view: 'Переглянути',
            selectedSlotRange: 'Обраний слот: {{start}} – {{end}}',
            freeHeader: '{{range}} · ВІЛЬНО',
            bookedHeader: '{{range}} · ЗАБРОНЬОВАНО',
            sessionHeader: '{{range}} · У ГРІ',
        },
        form: {
            newTitle: 'Нове бронювання',
            editTitle: 'Деталі бронювання',
            timeSlot: 'Часовий слот',
            startTime: 'Час початку',
            endTime: 'Час завершення',
            hourLabel: 'Година',
            durationLabel: 'Тривалість',
            customerLookup: 'Пошук клієнта',
            customerReadOnly: 'Клієнт',
            customerReadOnlyNote: 'Щоб змінити клієнта, скасуйте це бронювання та створіть нове.',
            searchUser: 'Знайти зареєстрованого користувача',
            orGuest: 'Або дані гостя',
            guestName: 'Ім’я гостя',
            guestPhone: 'Телефон (необов’язково)',
            selectedUser: 'Бронювання для {{name}}',
            playerCount: 'Кількість київ / гравців',
            playerCountPlaceholder: 'напр. 2',
            playerCountNote: 'Необов’язково — лише для вашої довідки; не зберігається у бронюванні.',
            makeRecurring: 'Зробити повторюваним',
            recurringComingSoon: 'Повторювані бронювання — скоро.',
            confirm: 'Зберегти бронювання',
            confirmPending: 'Підтвердити бронювання',
            save: 'Зберегти зміни',
            cancelBooking: 'Скасувати бронювання',
            startTable: 'Запустити стіл',
            timeConflict: 'Обраний час перетинається з наявним бронюванням.',
        },
        notifications: {
            created: 'Бронювання підтверджено.',
            updated: 'Бронювання оновлено.',
            cancelled: 'Бронювання скасовано.',
            unavailable: 'Стіл недоступний на обраний час.',
            failed: 'Не вдалося зберегти бронювання.',
        },
        pendingReview: {
            requestedSlotRange: 'Запит: {{start}} – {{end}}',
            tableTypeMismatch: 'Оберіть стіл запитаного типу.',
        },
    },
    markerNotifications: {
        title: 'Сповіщення',
        empty: 'Немає очікуючих сповіщень.',
        emptyHistory: 'Немає сповіщень за період зберігання.',
        emptyImportant: 'Немає важливих сповіщень.',
        emptyNotice: 'Немає повідомлень.',
        emptyImportantHistory: 'Немає важливих сповіщень за період зберігання.',
        emptyNoticeHistory: 'Немає повідомлень за період зберігання.',
        viewHistory: 'Переглянути всю історію',
        backToInbox: 'Назад до вхідних',
        unknownActor: 'Хтось',
        noticeDismissHint: 'Натисніть, щоб прибрати',
        overdueBooking: 'Прострочене бронювання · {{tableName}}',
        overdueHint: 'Гість може запізнитися — зателефонуйте та оновіть або скасуйте бронювання.',
        alertBanner: {
            message: '{{count}} важливих — натисніть для перегляду',
        },
        alert: {
            bookingRequest: 'Новий запит на бронювання ({{tableType}})',
            overdue: 'Прострочене бронювання на {{tableName}}',
            inquiry: 'Запит з сайту ({{tableType}})',
        },
        browserAlerts: {
            title: 'Сповіщення браузера',
            message: 'Увімкніть сповіщення, щоб отримувати попередження, коли вкладка Dashboard у фоні.',
            enable: 'Увімкнути сповіщення',
            notNow: 'Не зараз',
            blockedHint: 'Сповіщення заблоковано в браузері. Дозвольте їх у налаштуваннях сайту.',
            iosHint: 'На iPhone: додайте на головний екран для надійних фонових сповіщень.',
        },
        resolve: {
            title: 'Опрацювати запит на бронювання',
            message: 'Додайте необов’язкову примітку про те, як опрацьовано цей запит.',
            notePlaceholder: 'Примітка (необов’язково)',
            confirm: 'Опрацьовано',
            openBooking: 'Відкрити бронювання',
            resolvedByAt: 'Опрацював(ла) {{name}}: {{time}}',
            resolvedAt: 'Опрацьовано: {{time}}',
            resolutionNote: 'Примітка: {{note}}',
            tapHint: 'Натисніть, щоб опрацювати',
        },
        priority: {
            IMPORTANT: 'Важливе',
            NOTICE: 'Повідомлення',
        },
        status: {
            ACTIVE: 'Активне',
            DISMISSED: 'Прибрано',
            RESOLVED: 'Вирішено',
        },
        tableAction: {
            START: '{{actorName}} запустив(ла) «{{tableName}}»',
            PAUSE: '{{actorName}} призупинив(ла) «{{tableName}}»',
            RESUME: '{{actorName}} відновив(ла) «{{tableName}}»',
            STOP: '{{actorName}} зупинив(ла) «{{tableName}}»',
            FINISH_SET: '{{actorName}} завершив(ла) сет на «{{tableName}}»',
            MARK_LEFT: '{{actorName}} відмітив(ла) вихід гравця на «{{tableName}}»',
        },
        videoExportError: {
            title: 'Помилка експорту відео · {{tableName}}',
        },
        row: {
            date: 'Дата',
            time: 'Час',
            slot: 'Слот',
            user: 'Користувач',
            actor: 'Актор',
            phone: 'Телефон',
            notes: 'Примітки',
            tableType: 'Тип столу',
            error: 'Помилка',
        },
    },
    loyalty: {
        title: 'Програма лояльності',
        bonusBalance: 'Бонусний баланс',
        loyaltyPercent: 'Рівень лояльності',
        loyaltyPercentValue: '{{percent}}%',
        levelLabel: 'Рівень лояльності',
        levelValue: '{{level}} · {{percent}}%',
        tiers: {
            bronze: 'Бронза',
            silver: 'Срібло',
            gold: 'Золото',
            platinum: 'Платина',
        },
        infoTitle: 'Як працює лояльність',
        infoClose: 'Зрозуміло',
        infoIntro:
            'Після реєстрації Ви одразу отримуєте 50 грн на свій бонусний рахунок.',
        infoCashback:
            'На бонусний рахунок також накопичується від 5 до 20% з кожного чеку. Більше граєте — більше бонусів отримуєте:',
        infoTierBronze: 'Бронза — до 7 000 грн витрат → 5%',
        infoTierSilver: 'Срібло — від 7 001 до 12 000 грн → 10%',
        infoTierGold: 'Золото — від 12 001 до 20 000 грн → 15%',
        infoTierPlatinum: 'Платина — від 20 001 грн → 20%',
        infoBirthday:
            'І це ще не все: на день народження Ви отримуєте подарунок від БП Cluster — 200 грн на бонусний рахунок.',
        bonusesUnit: 'бонусів',
        registrationBonus: 'Бонус за реєстрацію',
        birthdayBonus: 'Бонус на день народження',
        graceDays: 'Пільговий період рівня (дні)',
        tiersTitle: 'Рівні витрат (12 місяців, готівка + картка)',
        tierMin: 'Мін. витрати (UAH)',
        tierMax: 'Макс. витрати (UAH)',
        tierPercent: 'Кешбек %',
        save: 'Зберегти налаштування',
        saved: 'Налаштування лояльності збережено.',
        loadFailed: 'Не вдалося завантажити налаштування лояльності.',
        cabinetTitle: 'Лояльність',
        cabinetHint: 'Бонуси можуть покрити до 50% вашого рахунку.',
        closeBill: {
            titleLine: 'Закрити рядок рахунку',
            titleWhole: 'Закрити весь рахунок',
            whoPays: 'Хто сплачує?',
            bonusBalance: 'Бонусний баланс',
            bonusesToUse: 'Бонусів до використання',
            total: 'Разом',
            bonuses: 'Бонуси',
            toPay: 'До сплати',
            payCash: 'Готівка',
            payCard: 'Картка',
            confirmPay: 'Підтвердити оплату',
            waiting: 'Очікування підтвердження оплати…',
            selectPayer: 'Будь ласка, оберіть, хто сплачує',
            invalidBonus: 'Некоректна сума бонусів',
            maxBonus: 'Макс. бонусів: {{amount}} (правило 50%)',
            paymentFailed: 'Оплата не вдалася',
            noteLabel: 'Примітка',
            notePlaceholder: 'Необовʼязкова примітка (напр. натиснули Картка помилково)',
        },
        userManagement: {
            bonusBalance: 'Бонуси',
            loyaltyRate: 'Рівень лояльності',
            adjustBonus: 'Скоригувати бонуси (+/-)',
            setBalance: 'Встановити баланс',
            deltaPlaceholder: '+50 або -10',
            balancePlaceholder: '0',
            note: 'Примітка (необов’язково)',
            apply: 'Застосувати',
            birthdayBlocked: 'Бонус на день народження заблоковано',
            revalidateBirthday: 'Повторно перевірити дату народження',
            revalidated: 'Право на бонус до дня народження відновлено.',
            adjustNonZero: 'Введіть ненульове коригування',
            invalidBalance: 'Введіть коректний баланс',
            updateFailed: 'Не вдалося оновити бонуси',
            revalidateFailed: 'Не вдалося повторно перевірити',
            updated: 'Бонусний баланс оновлено.',
        },
    },
    ratings: {
        title: 'Рейтинги',
        loadFailed: 'Не вдалося завантажити рейтинги.',
        loading: 'Завантаження…',
        yourRating: 'Ваш рейтинг',
        yourPlace: 'Місце {{place}}',
        searchPlaceholder: 'Знайти гравця в таблиці…',
        types: {
            pyramidAllBalls: 'Піраміда всіма кулями',
            pyramidOneBall: 'Піраміда однією кулею',
            pool: 'Пул',
        },
        table: {
            place: '#',
            name: 'Гравець',
            rating: 'Elo',
            empty: 'Поки немає гравців',
        },
        history: {
            title: '{{name}} — історія матчів',
            titleFallback: 'Історія матчів',
            section: 'Ваші матчі',
            ratingLine: 'Рейтинг {{rating}} · {{matches}} матчів',
            empty: 'Матчів ще немає',
            loadFailed: 'Не вдалося завантажити історію.',
        },
        match: {
            title: 'Ввести матч',
            playerA: 'Гравець A',
            playerB: 'Гравець B',
            searchPlayer: 'Пошук зареєстрованого гравця…',
            submit: 'Зберегти матч',
            selectPlayers: 'Оберіть обох гравців',
            invalidScores: 'Введіть коректні невідʼємні рахунки',
            noDraws: 'Нічиї не допускаються',
            winner: 'Переможець',
            loser: 'Той, хто програв',
            saved: 'Матч збережено.',
            saveFailed: 'Не вдалося зберегти матч.',
            updated: 'Матч оновлено.',
            updateFailed: 'Не вдалося оновити матч.',
            deleted: 'Матч видалено.',
            deleteFailed: 'Не вдалося видалити матч.',
        },
        adjust: {
            title: 'Встановити рейтинг (без історії)',
            placeholder: 'Рейтинг',
            apply: 'Встановити',
            invalid: 'Введіть коректний рейтинг',
            saved: 'Рейтинг оновлено.',
            failed: 'Не вдалося оновити рейтинг.',
        },
        userManagement: {
            title: 'Elo рейтинги',
            meta: 'Рейтинг {{rating}} · {{matches}} матчів',
        },
        openButton: 'Рейтинги',
        recentMatches: {
            button: 'Історія',
            title: 'Останні матчі',
            loadFailed: 'Не вдалося завантажити останні матчі.',
            empty: 'Матчів ще немає.',
            columns: {
                date: 'Дата',
                score: 'Рахунок',
                deltaA: 'ΔA',
                deltaB: 'ΔB',
            },
        },
        tournament: {
            button: 'Турніри',
            listTitle: 'Турніри',
            noTournaments: 'Турнірів ще немає.',
            participants: '{{count}} учасників',
            createTitle: 'Новий турнір',
            namePlaceholder: 'Назва турніру',
            create: 'Створити',
            createFailed: 'Не вдалося створити турнір.',
            loadFailed: 'Не вдалося завантажити турніри.',
            detailLoadFailed: 'Не вдалося завантажити турнір.',
            addParticipantSearch: 'Пошук гравця для додавання…',
            addParticipant: 'Додати',
            addParticipantFailed: 'Не вдалося додати учасника.',
            removeParticipantFailed: 'Не вдалося видалити учасника.',
            participantColumns: {
                elo: 'Elo',
                player: 'Гравець',
            },
            matchTitle: 'Додати матч',
            selectPlayer: 'Оберіть гравця…',
            submitMatch: 'Зберегти матч',
            matchSaved: 'Матч збережено.',
            matchSaveFailed: 'Не вдалося зберегти матч.',
            deleteTournament: 'Видалити турнір',
            deleteConfirm: 'Видалити цей турнір?',
            deleteCancel: 'Скасувати',
            deleted: 'Турнір видалено.',
            deleteFailed: 'Не вдалося видалити турнір.',
        },
    },
    settings: {
        title: 'Налаштування',
        sections: {
            communicationChannels: 'Канали сповіщень',
            markerNotifications: 'Сповіщення маркера',
            tariffs: 'Тарифи',
            loyalty: 'Програма лояльності',
            videoSettings: 'Завантаження відео (YouTube)',
            videoPricing: 'Ціни на відео',
        },
        communicationChannels: {
            email: 'Email',
            telegram: 'Telegram',
            save: 'Зберегти налаштування сповіщень',
            saved: 'Налаштування сповіщень збережено.',
            loadFailed: 'Не вдалося завантажити налаштування сповіщень.',
            categories: {
                registrationAuth: 'Реєстрація / скидання пароля',
                registrationAuthHint: 'Підтвердження реєстрації, зміна email, активація, скидання пароля',
                loyalty: 'Лояльність',
                bills: 'Рахунки',
            },
        },
        videoSettings: {
            sectionTitle: "Завантаження відео (YouTube)",
            defaultHashtags: "Стандартні хештеги",
            defaultHashtagsPlaceholder: "#billiards #pool #snooker",
            descriptionTemplate: "Шаблон опису",
            descriptionTemplatePlaceholder: "Записано в клубі",
            youtubeStatus: "Підключення YouTube",
            connected: "Підключено · {{channel}}",
            notConnected: "Не підключено",
            connectBtn: "Підключити акаунт YouTube",
            revokeHint: "Для повного відкликання доступу відвідайте налаштування акаунта Google.",
            reAuthBtn: "Повторна авторизація",
            disconnectBtn: "Відключити",
            disconnected: "Акаунт YouTube відключено.",
            save: "Зберегти",
            saved: "Налаштування відео збережено.",
            saveFailed: "Не вдалося зберегти налаштування відео.",
            loadFailed: "Не вдалося завантажити налаштування відео.",
            ytConnectedSuccess: "Акаунт YouTube успішно підключено.",
            notConfigured: "Облікові дані YouTube не налаштовані на сервері (YOUTUBE_CLIENT_ID/SECRET).",
            channelsTitle: 'Резервні канали YouTube',
            channelsHint: 'Трансляції пробують канали в цьому порядку і переходять до наступного, якщо канал вичерпав квоту або токен прострочився. Токени Google діють приблизно тиждень — перепідключайте канал завчасно.',
            addChannel: 'Додати канал',
            noChannels: 'Ще немає підключених каналів.',
            channelReconnect: 'Перепідключити',
            channelDisconnect: "Відключити",
            channelDelete: 'Видалити',
            channelDeleteConfirm: 'Видалити цей канал зі списку резервних?',
            channelMoveUp: '↑',
            channelMoveDown: '↓',
            channelStatus: {
                CONNECTED: 'Підключено',
                EXPIRING_SOON: 'Термін дії спливає',
                EXPIRED: 'Прострочено — перепідключіть',
                NOT_CONNECTED: 'Не підключено',
            },
            events: {
                title: 'Журнал подій трансляції',
                empty: 'Подій ще немає.',
                manualKey: 'Ручний ключ',
                tableChannel: 'Стіл {{table}} · {{channel}}',
                prev: '← Назад',
                next: 'Далі →',
                type: {
                    CREATED: 'Створено',
                    REUSED: 'Повторно використано',
                    FAILED: 'Помилка',
                    TRANSITIONED_LIVE: 'В ефірі',
                    TRANSITIONED_COMPLETE: 'Завершено',
                },
            },
        },
        videoPricing: {
            videoUahPerHour: 'Повне відео',
            lateUahPerHour: 'Пізній запис',
            foulUahFlat: 'Перегляд порушення',
            clipBase: 'Нарізка — базова ціна',
            clipFreeMinutes: 'Базові хвилини',
            clipPerMin: 'Нарізка — за хвилину понад',
            unitHour: 'грн/год',
            unitFlat: 'грн',
            unitMin: 'грн/хв',
            unitMinutes: 'хв',
            save: 'Зберегти ціни',
            saved: 'Ціни на відео збережено.',
            saveFailed: 'Помилка збереження цін на відео.',
            loadFailed: 'Помилка завантаження цін на відео.',
        },
        markerNotifications: {
            hint: 'Важливі сповіщення блимають і сповіщають персонал. Повідомлення лише збільшують лічильник. Вимкнено — не створюються.',
            retentionDays: 'Зберігання історії (днів)',
            retentionInvalid: 'Зберігання має бути від 1 до 90 днів.',
            save: 'Зберегти налаштування сповіщень маркера',
            saved: 'Налаштування сповіщень маркера збережено.',
            loadFailed: 'Не вдалося завантажити налаштування сповіщень маркера.',
            modes: {
                important: 'Важливе',
                notice: 'Повідомлення',
                off: 'Вимкнено',
            },
            types: {
                bookingRequest: 'Запити на бронювання',
                overdueBooking: 'Прострочені бронювання',
                tableActions: 'Дії зі столами',
            },
        },
    },
    common: {
        duplicateValue: "Поле '{{field}}' вже використовується",
        fieldNames: {
            email: 'Email',
            phone: 'Телефон',
            full_name: "Повне ім'я",
        },
        cancel: 'Скасувати',
        confirm: 'Підтвердити',
        back: 'Назад',
        save: 'Зберегти',
        create: 'Створити',
        search: 'Пошук',
        retry: 'Повторити',
        yes: 'Так',
        no: 'Ні',
        delete: 'Видалити',
        edit: 'Редагувати',
        all: 'Усі',
        next: 'Далі',
        previous: 'Назад',
        close: 'Закрити',
        continue: 'Продовжити',
        login: 'Увійти',
        register: 'Зареєструватися',
        loading: 'Завантаження...',
        comingSoon: 'Скоро',
        comingSoonFeature: '{{feature}} скоро з’явиться.',
        notAvailable: 'Н/Д',
        datePlaceholder: 'YYYY-MM-DD',
        active: 'Активний',
        userView: '👤 Користувацький вигляд',
        adminView: '🎱 Адмін-панель',
        telegramBotBlocked: 'Сповіщення Telegram вимкнені. Будь ласка, розблокуйте бот Pool Control, щоб отримувати сповіщення.',
    },
    dashboard: {
        loadingTitle: 'Більярдні столи',
        loadingMessage: 'Завантаження столів...',
        title: 'Панель Pool Control',
        welcome: 'Вітаємо, {{name}} ({{role}})',
        logout: 'Вийти',
        stats: {
            totalTables: 'Cтолів',
            active: 'Активні',
            paused: 'На паузі',
            idle: 'Вільні',
            bills: 'Рахунки',
            users: 'Користувачі',
            tariffs: 'Тарифи',
            loyalty: 'Лояльність',
            reports: 'Звіти',
            bookings: 'Бронювання',
            rivalSearch: 'Пошук суперника',
            ratings: 'Рейтинги',
            video: 'Відео',
            settings: 'Налаштування',
            notifications: 'Сповіщення',
        },
        legendTitle: 'Легенда статусів:',
        legend: {
            idle: 'Вільний (доступний)',
            paused: 'На паузі',
            active: 'Активний (у використанні)',
            booked: 'Заброньований',
            maintenanceOffline: 'Обслуговування/Офлайн',
            error: 'Помилка',
        },
        noTables: 'У системі не зареєстровано жодного столу',
    },
    auth: {
        login: {
            title: 'З поверненням',
            subtitle: 'Увійдіть до свого облікового запису {{clubName}}',
            emailOrPhone: 'Email або телефон',
            emailOrPhoneRequired: 'Email або телефон обов’язковий',
            emailOrPhoneInvalid: 'Введіть коректний email або телефон у форматі +380...',
            emailOrPhonePlaceholder: 'Email або телефон у форматі +380...',
            password: 'Пароль',
            passwordRequired: 'Пароль обов’язковий',
            passwordPlaceholder: 'Введіть ваш пароль',
            forgotPassword: 'Забули пароль?',
            continue: 'Продовжити',
            login: 'Увійти',
            back: 'Назад',
            cancel: 'Скасувати',
            continueGoogle: 'Продовжити з Google',
            continueApple: 'Продовжити з Apple ID',
            activationSent: 'Ми надіслали посилання для активації{{destination}}. Відкрийте посилання, щоб створити пароль і завершити налаштування.',
            activationDestination: ' на {{hint}}',
            openTelegramBot: 'Відкрити Telegram-бот',
            resendActivation: 'Надіслати посилання для активації повторно',
            notFound: 'Ми не змогли знайти обліковий запис із цим телефоном чи email. Будь ласка, зверніться до адміністратора.',
            socialHint: 'Використовуйте {{provider}}, щоб увійти до цього облікового запису.',
            socialHintFallback: 'Google або Apple',
        },
        register: {
            title: 'Створити обліковий запис',
            subtitle: 'Приєднуйтесь до системи Pool Control',
            tabEmail: 'Email',
            tabPhone: 'Телефон',
            tabTelegram: 'Telegram',
            tabSocial: 'Соцмережі',
            openTelegramBot: 'Відкрити Telegram-бот',
            telegramSubtitle: 'Реєстрація в Telegram — відкрийте бота, поділіться номером, потім завершіть у застосунку.',
            consent: 'Я дозволяю зберігати мою особисту інформацію для потреб облікового запису та розрахунків.',
            consentRequired: 'Для реєстрації потрібна згода.',
            register: 'Зареєструватися',
            cancel: 'Скасувати',
            continueGoogle: 'Продовжити з Google',
            continueApple: 'Продовжити з Apple ID',
            socialNote: 'Наступного разу ви увійдете через Google або Apple. Пароль не потрібен.',
            telegramInviteSubtitle: 'Завершіть реєстрацію — номер телефону з Telegram.',
            inviteInvalid: 'Це посилання з Telegram недійсне або прострочене. Відскануйте QR-код клубу ще раз.',
        },
        activation: {
            title: 'Створіть свій пароль',
            password: 'Введіть новий пароль',
            confirmPassword: 'Підтвердіть новий пароль',
            dob: 'Дата народження (необов’язково)',
            dobPlaceholder: 'YYYY-MM-DD',
            photoUrl: 'URL фото профілю (необов’язково)',
            photoPlaceholder: 'https://...',
            finishSetup: 'Завершити налаштування',
            skipOptional: 'Пропустити необов’язкові поля',
        },
        registrationPending: {
            title: 'Завершіть реєстрацію',
            subtitle: 'Виконайте наведені нижче кроки, щоб активувати ваш обліковий запис.',
            confirmEmail: 'Підтвердіть свій email',
            confirmEmailBody: 'Ми надіслали посилання на {{destination}}. Відкрийте його, щоб підтвердити адресу.',
            resendEmail: 'Надіслати email повторно',
            confirmPhone: 'Підтвердіть свій телефон (SMS)',
            confirmPhoneBody: 'Ми надіслали посилання на {{destination}}. Відкрийте його, щоб підтвердити.',
            resendSms: 'Надіслати SMS повторно',
            confirmTelegram: 'Підтвердіть у Telegram',
            confirmTelegramBody: 'Ми надіслали посилання для підтвердження в @Cluster_palace_bot. Відкрийте його, щоб завершити реєстрацію.',
            verifyTelegram: 'Підтвердіть телефон у Telegram',
            telegramBody: 'Відкрийте @Cluster_palace_bot і поділіться своїм контактом, щоб підтвердити номер телефону.',
            telegramHint: 'Чеки за рахунками також можна надсилати на ваш email, якщо Telegram не підключено.',
            openTelegram: 'Відкрити Telegram',
            continueApp: 'Перейти до застосунку',
            backHome: 'На головну',
            yourEmail: 'ваш email',
            yourPhone: 'ваш телефон',
        },
        forgotPassword: {
            title: 'Скидання пароля',
            subtitle: 'Введіть email або телефон. Ми надішлемо посилання для скидання в Telegram або на email.',
            emailOrPhone: 'Email або телефон',
            emailOrPhonePlaceholder: 'Введіть ваш email або номер телефону',
            emailOrPhoneRequired: 'Email або телефон обов’язковий',
            submit: 'Надіслати посилання',
            sent: 'Якщо обліковий запис існує, ми надіслали посилання для скидання пароля{{destination}}. Відкрийте посилання, щоб задати новий пароль.',
            sentDestination: ' на {{hint}}',
            resend: 'Надіслати повторно',
            backToLogin: 'Повернутися до входу',
            close: 'Закрити',
        },
        passwordReset: {
            title: 'Задайте новий пароль',
            password: 'Новий пароль',
            confirmPassword: 'Підтвердіть новий пароль',
            submit: 'Скинути пароль',
            success: 'Ваш пароль змінено. Будь ласка, увійдіть з новим паролем.',
        },
    },
    splash: {
        title: 'Pool Control',
        tagline: 'Керуйте більярдними столами ефективно',
        login: 'Увійти',
        register: 'Зареєструватися',
        continueApp: 'Перейти до застосунку',
        logout: 'Вийти',
    },
    userManagement: {
        title: 'Керування користувачами',
        searchPlaceholder: 'Пошук за іменем, email, телефоном...',
        addUser: '+ Додати користувача',
        empty: 'Немає користувачів, що відповідають обраним фільтрам.',
        email: 'Email: {{value}}',
        phone: 'Телефон: {{value}}',
        role: 'Роль: {{role}}',
        deleteConfirm: 'Видалити?',
        pageOf: 'Сторінка {{page}} з {{total}}',
        notifications: {
            updated: 'Користувача успішно оновлено',
            created: 'Користувача успішно створено',
            deleted: 'Користувача успішно видалено',
            saveFailed: 'Не вдалося зберегти користувача',
            deleteFailed: 'Не вдалося видалити користувача',
        },
    },
    userMerge: {
        openButton: 'Об’єднати акаунти',
        title: 'Об’єднання акаунтів',
        hint: 'Виняткове виправлення: об’єднати два дублікати в один. Історія та бонуси переходять до збереженого акаунту.',
        leftAccount: 'Лівий акаунт',
        rightAccount: 'Правий акаунт',
        searchPlaceholder: 'Пошук за іменем, email, телефоном...',
        compare: 'Порівняти',
        preview: 'Переглянути результат',
        confirm: 'Підтвердити об’єднання',
        keepAccount: 'Залишити id акаунту:',
        keepLeft: 'Лівий #{{id}}',
        keepRight: 'Правий #{{id}}',
        field: 'Поле',
        left: 'Лівий',
        right: 'Правий',
        pick: 'Вибір',
        result: 'Результат',
        loyaltyTitle: 'Лояльність',
        loyaltyLine: 'Бонуси: лівий {{left}} + правий {{right}} → {{result}}',
        historyTitle: 'Історія перейде до збереженого',
        historyLine: 'Рядки рахунків {{leftBills}}/{{rightBills}}, бронювання {{leftBookings}}/{{rightBookings}} (лівий/правий)',
        discardNote: 'Акаунт #{{id}} буде видалено після об’єднання.',
        fields: {
            fullName: 'Прізвище, ім’я та по батькові',
            email: 'Email',
            phone: 'Телефон',
            birthDate: 'Дата народження',
            photoUrl: 'URL фото',
            role: 'Роль',
            authProvider: 'Провайдер входу',
            telegramChatId: 'Telegram чат',
            billNotificationChannel: 'Сповіщення про рахунок',
            preferredLocale: 'Мова',
            enabled: 'Активний',
        },
        errors: {
            pickTwoDifferent: 'Оберіть двох різних користувачів для порівняння.',
            previewFailed: 'Не вдалося побудувати попередній перегляд.',
            mergeFailed: 'Не вдалося об’єднати акаунти.',
        },
        notifications: {
            merged: 'Акаунти успішно об’єднано.',
        },
    },
    userForm: {
        createTitle: 'Створити нового користувача',
        editTitle: 'Редагувати користувача',
        registerTitle: 'Створити обліковий запис',
        fullName: 'Прізвище, ім’я та по батькові',
        fullNamePlaceholder: 'Введіть ПІБ',
        email: 'Email',
        emailRequired: 'Email *',
        emailOptional: 'Email (необов’язково)',
        emailPlaceholder: 'Введіть email',
        phone: 'Телефон',
        phoneRequired: 'Телефон *',
        phoneOptional: 'Телефон (необов’язково)',
        phonePlaceholder: 'Введіть телефон (E.164, напр. +380...)',
        phoneFromTelegram: 'Номер телефону з Telegram',
        telegramChatId: 'Telegram Chat ID',
        telegramChatIdPlaceholder: 'Числовий chat id з бота',
        telegramChatIdHint: 'Залиште порожнім, щоб відв’язати. Клієнт може отримати Chat ID в клубному боті після /start.',
        password: 'Пароль *',
        passwordPlaceholder: 'Введіть пароль (мін. 8 символів)',
        confirmPassword: 'Підтвердіть пароль *',
        confirmPasswordPlaceholder: 'Підтвердіть пароль',
        role: 'Роль',
        roleWarning: 'У вас немає дозволу змінювати роль цього користувача',
        specialStatus: 'Спеціальний статус',
        military: 'Військовий',
        militaryHintAdmin: 'Лише Admin+ після перевірки документа. Користувач не може встановити це сам.',
        militaryHintMarker: 'Лише Admin або Superadmin може змінювати статус військового.',
        activationNote: 'Примітка: користувач активує доступ під час першого входу',
        birthDate: 'Дата народження',
        birthDateOptional: '* Не обов’язково',
        birthDateLocked: 'Дату народження можна встановити лише один раз. Зверніться до маркера, щоб змінити її.',
        errors: {
            fullNameRequired: 'Повне ім’я обов’язкове',
            fullNameMin: 'Повне ім’я має містити щонайменше 2 символи',
            emailRequired: 'Email обов’язковий',
            phoneRequired: 'Телефон обов’язковий',
            contactRequired: 'Введіть щонайменше email або телефон',
            invalidEmail: 'Некоректний формат email',
            invalidPhone: 'Телефон має починатися з + і містити лише цифри (напр. +380...)',
            passwordRequired: 'Пароль обов’язковий',
            passwordMin: 'Пароль має містити щонайменше 8 символів',
            confirmRequired: 'Будь ласка, підтвердіть свій пароль',
            passwordMismatch: 'Паролі не збігаються',
        },
    },
    userCabinet: {
        title: 'Налаштування облікового запису',
        subtitle: 'Ваш особистий кабінет',
        profile: 'Профіль',
        notifications: 'Сповіщення',
        security: 'Безпека',
        editProfile: 'Редагувати профіль',
        editProfileMessage: 'Оновіть ім’я, контактні дані та дату народження.',
        profileEditTitle: 'Ваш профіль',
        profileEditSubtitle: 'Оновіть особисті дані',
        billCheckChannel: 'Канал для чеків рахунків',
        billCheckMessage: 'Оберіть Telegram або email для чеків за рахунками.',
        changePassword: 'Змінити пароль',
        changePasswordMessage: 'Зміна пароля з підтвердженням поточного пароля.',
        changePasswordModal: {
            title: 'Змінити пароль',
            currentPassword: 'Поточний пароль',
            newPassword: 'Новий пароль',
            confirmPassword: 'Підтвердіть новий пароль',
            submit: 'Оновити пароль',
            cancel: 'Скасувати',
            success: 'Пароль успішно оновлено.',
        },
    },
    tariffManagement: {
        title: 'Керування тарифами',
        moveUp: 'Перемістити вгору',
        moveDown: 'Перемістити вниз',
        addTariff: '+ Додати тариф',
        columns: {
            name: 'Назва',
            price: 'Ціна',
            when: 'Коли',
            kind: 'Тип',
            priority: 'Пріоритет',
            active: 'Активний',
        },
        empty: 'Немає тарифів для цього типу столу',
    },
    tariffEdit: {
        addTitle: 'Додати тариф',
        editTitle: 'Редагувати тариф',
        name: 'Назва',
        namePlaceholder: 'Назва тарифу',
        tableType: 'Тип столу',
        pricePerHour: 'Ціна за годину (UAH)',
        startTime: 'Час початку (HH:mm, необов’язково)',
        endTime: 'Час завершення (HH:mm, необов’язково)',
        daysOfWeek: 'Дні тижня (залиште порожнім = усі дні)',
        tariffKind: 'Тип тарифу',
        priority: 'Пріоритет (вищий = перевіряється першим)',
        active: 'Активний',
        errors: {
            nameRequired: 'Назва обов’язкова',
            invalidPrice: 'Некоректна ціна',
            overnightRange: 'Нічні діапазони (напр. 23:00–08:00) не дозволені як єдиний тариф. Натомість створіть два тарифи: напр. 23:00–23:59 та 00:00–08:00.',
            saveFailed: 'Не вдалося зберегти',
        },
        notifications: {
            created: 'Тариф створено',
            updated: 'Тариф оновлено',
        },
    },
    tariffRule: {
        allDays: 'Усі дні',
        allDay: 'цілий день',
        allDaysAllDay: 'Усі дні, цілий день',
        from: 'з {{time}}',
        until: 'до {{time}}',
    },
    enums: {
        tableStatus: {
            IDLE: 'Вільний',
            ACTIVE: 'Активний',
            PAUSED: 'На паузі',
            MAINTENANCE: 'Обслуговування',
            OFFLINE: 'Офлайн',
            ERROR: 'Помилка',
            BOOKED: 'Заброньований',
        },
        tableType: {
            POOL: 'Пул',
            PYRAMID: 'Піраміда',
            SNOOKER: 'Снукер',
            VIP: 'VIP',
        },
        userRole: {
            USER: 'Користувач',
            MARKER: 'Маркер',
            ADMIN: 'Адміністратор',
            SUPERADMIN: 'Суперадміністратор',
            SERVICE: 'Сервісний',
        },
        bookingStatus: {
            PENDING: 'Очікує',
            CONFIRMED: 'Підтверджено',
            CANCELLED: 'Скасовано',
            COMPLETED: 'Завершено',
            NO_SHOW: 'Не з’явився',
        },
        daysOfWeek: {
            MONDAY: 'Пн',
            TUESDAY: 'Вт',
            WEDNESDAY: 'Ср',
            THURSDAY: 'Чт',
            FRIDAY: 'Пт',
            SATURDAY: 'Сб',
            SUNDAY: 'Нд',
        },
        tariffKind: {
            USUAL: 'Звичайний',
            MILITARY: 'Військовий',
            STUDENT: 'Учнівський',
        },
    },
    searchableInput: {
        noResults: 'Немає результатів',
        searchFailed: 'Помилка пошуку',
        searching: 'Пошук...',
        placeholder: 'Введіть для пошуку...',
    },
    passwordField: {
        showPassword: 'Показати пароль',
        hidePassword: 'Приховати пароль',
    },
    playerSearch: {
        registered: 'Зареєстрований',
    },
    userDetails: {
        confirming: 'Підтвердження реєстрації...',
        title: 'Завершіть профіль',
        subtitle: 'Додайте відсутню інформацію, щоб завершити реєстрацію',
        fullName: "Повне ім'я",
        fullNamePlaceholder: "Ваше повне ім'я",
        email: 'Email',
        emailPlaceholder: 'your@email.com',
        emailReadOnlyHint: 'Email керується вашим провайдером входу і не може бути змінений тут.',
        emailChangePending: 'Підтвердження надіслано на {{email}}. Перевірте пошту, щоб підтвердити нову адресу.',
        emailChangeConfirmed: 'Вашу нову електронну адресу підтверджено.',
        emailConfirmationSent: 'Лист із підтвердженням надіслано. Перевірте пошту, щоб підтвердити нову адресу.',
        phone: 'Телефон *',
        phoneOptional: 'Телефон',
        phonePlaceholder: '+380...',
        birthDate: 'Дата народження',
        birthDatePlaceholder: '1990-01-01',
        birthDateOptional: 'Необов’язково — можна встановити лише один раз',
        birthDateLocked: 'Дату народження можна встановити лише один раз.',
        saveDetails: 'Зберегти дані',
        saved: 'Дані профілю збережено.',
        profileUpdated: 'Профіль оновлено.',
    },
    video: {
        title: "Відео",
        selectTable: "Оберіть стіл",
        selectTableHint: "Оберіть стіл із камерою, щоб почати.",
        noCameraTables: "Столів із налаштованими камерами немає.",
        tabs: {
            foulReview: "Перегляд фолу",
            clipEdit: "Монтаж кліпу",
            youtubeLive: "YouTube Live",
        },
    },
    clipEditing: {
        title: "Монтаж кліпу",
        setIn: "Встановити початок",
        inSet: "Поч.: {{time}}",
        setOut: "Встановити кінець",
        outSet: "Кін.: {{time}}",
        clear: "Очистити",
        duration: "Тривалість кліпу: {{duration}}",
        invalidRange: "Кінцева точка має бути пізніше початкової.",
        notifyPlayer: "Повідомити гравця через Telegram",
        noNotify: "Без повідомлення",
        noTelegram: "У цього гравця немає прив’язаного Telegram-акаунта.",
        exportQueued: "Кліп додано до черги на експорт.",
        submitFailed: "Помилка експорту: {{message}}",
        exportRunning: "Експортування кліпу…",
        exportReady: "Кліп готовий!",
        download: "Завантажити",
        downloadFailed: "Не вдалося отримати посилання для завантаження.",
        exportFailed: "Помилка експорту: {{error}}",
        submit: "Експортувати кліп",
        newClip: "Новий кліп",
        payerLabel: "Платник / повідомити",
        payerPlaceholder: "Пошук гравця…",
    },
    comingSoonBanner: {
        defaultMessage: "Ця функція з’явиться в наступному оновленні.",
    },
    locale: {
        switchToEnglish: 'Перемкнути на англійську',
        switchToUkrainian: 'Перемкнути на українську',
    },
    streaming: {
        status: {
            live: 'В ЕФІРІ',
            preparing: 'ПІДГОТОВКА',
            failed: 'ПОМИЛКА',
        },
        form: {
            player1Name: 'Гравець 1',
            player2Name: 'Гравець 2',
            playerNamePlaceholder: "Повне ім'я",
            handicap: 'Гандикап',
            bestOf: 'К-сть партій',
            matchDuration: 'Час матчу, хвилини (OBS оверлей)',
            matchDurationCustom: 'Свій',
            matchDurationHint: 'Загальний зворотний відлік матчу на OBS оверлеї. Стартує з першою дією таймера удару і зупиняється на паузі. Залиште порожнім, щоб не показувати.',
            tournamentName: 'Турнір',
            stage: 'Стадія турніру',
            stagePlaceholder: 'напр. Чвертьфінал',
            descriptionPrefix: 'Опис трансляції',
            optional: "Необов'язково",
            channel: 'Канал',
            channelAuto: 'Авто (перемикання)',
        },
        controls: {
            startStream: 'Розпочати трансляцію ▶',
            stopStream: 'Зупинити трансляцію',
            matchScore: 'Перемоги в матчі',
            gameScore: 'Рахунок партії',
            break: 'Пауза ⏸',
            resume: 'Продовжити ▶',
            volume: 'Гучність',
            apply: 'Застосувати',
            startObsSession: 'Розпочати сесію OBS-оверлею',
            obsOverlayUrl: 'URL оверлею для OBS (Browser Source)',
            copyOverlayUrl: 'Копіювати URL оверлею',
            obsHint: 'Сесія OBS: трансляцію на YouTube і стрім запускайте самостійно в OBS.',
            copyLink: 'Копіювати посилання',
            makePublic: 'Зробити публічним',
            alreadyPublic: 'Публічний',
            noStreamUrl: 'Немає URL (ручний ключ трансляції)',
            editDetails: 'Редагувати деталі',
            saveDetails: 'Зберегти',
            cancelEditDetails: 'Скасувати',
            clearTemplate: 'Очистити збережений шаблон',
            liveVia: 'В ефірі через:',
            commentary: 'Мікрофон коментатора',
            commentaryStart: 'Увімкнути',
            commentaryStop: 'Вимкнути',
        },
        presets: {
            button: 'Збережені налаштування',
            title: 'Збережені налаштування трансляції',
            namePlaceholder: "Назва набору",
            saveNew: 'Зберегти як новий',
            load: 'Завантажити',
            update: 'Оновити',
            delete: 'Видалити',
            empty: 'Ще немає збережених налаштувань.',
            close: 'Закрити',
        },
        confirm: {
            winsPlus: 'Гравець {{name}} виграв партію?',
            winsMinus: 'Редагувати рахунок матчу?',
            confirmBtn: 'Так',
            cancelBtn: 'Скасувати',
        },
        notifications: {
            streamStarted: 'Трансляцію розпочато.',
            streamStopped: 'Трансляцію зупинено.',
            streamFailed: 'Не вдалося розпочати трансляцію.',
            scoreSaved: 'Рахунок оновлено.',
            breakStarted: 'Паузу активовано.',
            breakStopped: 'Паузу завершено.',
            obsSessionStarted: 'Сесію OBS-оверлею розпочато.',
            overlayUrlCopied: 'URL оверлею скопійовано.',
            linkCopied: 'Посилання скопійовано.',
            madePublic: 'Трансляція стала публічною на YouTube.',
            detailsSaved: 'Деталі оновлено.',
            commentaryDropped: "З'єднання коментатора перервано.",
        },
        errors: {
            playerNamesRequired: 'Вкажіть імена гравців.',
            matchDurationInvalid: 'Час матчу має бути від 1 до 600 хвилин.',
            noStreamKey: 'Ключ трансляції YouTube не налаштовано для цього стола. Встановіть його в Налаштуваннях відео → YouTube Live.',
            micUnavailable: 'Не вдалося отримати доступ до мікрофона.',
        },
        settings: {
            streamTablesTitle: 'Ключі трансляцій (за столом)',
            streamKey: 'Ключ трансляції YouTube',
            bitrateKbps: 'Бітрейт (кбіт/с)',
            save: 'Зберегти',
            saved: 'Збережено.',
            saveFailed: 'Помилка збереження.',
            resetStream: 'Скинути стрім',
            resetStreamConfirm: 'Скинути liveStream YouTube для цього столу? При наступному старті буде створено новий стрім.',
            resetStreamDone: 'Стрім скинуто. При наступному старті буде створено новий liveStream.',
            resetStreamFailed: 'Помилка скидання.',
            sponsorsTitle: 'Спонсори',
            sponsorName: 'Назва',
            sponsorType: 'Тип',
            sponsorFilePath: 'Шлях до зображення на сервері',
            sponsorPosX: 'X',
            sponsorPosY: 'Y',
            sponsorWidth: 'Ш',
            sponsorHeight: 'В',
            sponsorOrder: 'Порядок',
            addSponsor: 'Додати спонсора',
            deleteSponsor: 'Видалити',
            previewLogo: 'Перегляд',
            logoNotFound: 'Файл логотипу не знайдено на сервері.',
            sponsorAdded: 'Спонсора додано.',
            sponsorUpdated: 'Спонсора оновлено.',
            sponsorDeleted: 'Спонсора видалено.',
            editSponsor: 'Редагувати спонсора',
            saveChanges: 'Зберегти зміни',
            cancelEdit: 'Скасувати',
            previewScene: 'Попередній перегляд сцени',
            exportSponsors: 'Експорт спонсорів (.json)',
            importSponsors: 'Імпорт спонсорів (.json)',
            sponsorsExported: 'Спонсорів експортовано.',
            sponsorsImported: 'Спонсорів імпортовано — попередній список замінено.',
            sponsorsImportFailed: 'Помилка імпорту — перевірте, що файл є коректним JSON зі спонсорами.',
            sponsorTypes: {
                CLUB: 'Логотип клубу',
                MAJOR: 'Головний спонсор',
                MINOR: 'Другорядний спонсор',
            },
            reAuthWarning: 'YouTube Live потребує повторної авторизації (новий scope: youtube.force-ssl). Будь ласка, підключіть YouTube-акаунт повторно в розділі «YouTube Upload».',
        },
    },
    serviceScore: {
        noStream: 'Немає активного стриму.',
        noStreamHint: 'Зверніться до адміністратора.',
        matchScore: 'РАХУНОК МАТЧУ',
        gameScore: 'РАХУНОК ПАРТІЇ',
        tableLabel: 'Стіл',
        serviceTable: 'Сервісний стіл',
        serviceTableRequired: 'Обовʼязково для сервісних акаунтів',
        newPassword: 'Новий пароль',
        newPasswordPlaceholder: 'Залиште порожнім, щоб не змінювати',
        newPasswordHint: 'Стандартний пароль — "password". Змініть тут за потреби.',
        confirmLogout: 'Вийти з цього пристрою для рахунку?',
        extended: {
            toggleOn: 'Розширене табло (таймер удару)',
            toggleOff: 'Повернутися до стандартного табло',
            reset: 'СКИНУТИ',
            extend: '+30с',
            switchPlayer: 'ЗМІНА',
            start: 'СТАРТ',
            pause: 'ПАУЗА',
            resume: 'ПРОДОВЖИТИ',
            sound: 'Звук',
            soundOff: 'Вимкнено',
            expired: 'ЧАС',
            timeout: 'ТАЙМ-АУТ',
            timeoutEnd: 'ЗАВЕРШИТИ ТАЙМ-АУТ',
            matchTime: 'ЗАЛИШИЛОСЬ ЧАСУ МАТЧУ',
            keepAwakeHint: 'Порада: вимкніть автоблокування на цьому пристрої, щоб екран не гас.',
            extAvailable: '+30с ще доступно',
        },
    },
} as const